"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  primary: {
    backgroundColor: 'white',
    bg: 'white',
    borderColor: 'orange',
    borderRadius: '0',
    borderStyle: 'solid',
    borderWidth: '3px',
    color: 'orange',
    cursor: 'pointer',
    fontFamily: 'mrEaves',
    fontSize: 5,
    fontWeight: 'bold',
    lineHeight: '1em',
    px: 5,
    py: 3,
    textAlign: 'center',
    textDecoration: 'none',
    textTransform: 'uppercase',
    transitionDuration: '0.3s',
    transitionProperty: 'color, background-color',
    ':hover': {
      textDecoration: 'none',
      backgroundColor: 'orange',
      color: 'white'
    }
  },
  a11y: {
    background: 'none',
    border: 'none',
    padding: '0',
    margin: '0',
    width: '100%'
  },
  menu: {},
  invisible: {
    backgroundColor: 'transparent',
    border: 'none',
    padding: '0',
    margin: '0',
    '&:hover': {
      backgroundColor: 'none'
    },
    '&:focus': {
      border: 'none'
    }
  }
};
exports.default = _default;